import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  jobs: {
    id: 'navigationMenu.jobs',
    defaultMessage: 'Työt',
  },
  shifts: {
    id: 'navigationMenu.shifts',
    defaultMessage: 'Vuorot',
  },
  messages: {
    id: 'navigationMenu.messages',
    defaultMessage: 'Viestit',
  },
  settings: {
    id: 'navigationMenu.settings',
    defaultMessage: 'Asetukset',
  },
})
